module.exports = __webpack_public_path__ + "assets/img/Ultimate-Ears-Social-Static-Ad-Mobile-w540.22f31aba.webp";